import React from 'react';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { FlutterwaveConfig } from 'flutterwave-react-v3/dist/types';
import { useForm } from 'react-hook-form';
import { usePaystackPayment } from 'react-paystack';
import { PaystackProps } from 'react-paystack/dist/types';
import { useHistory, useLocation } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  formatMoney,
  getRequiredErrorMessage,
} from '../../../utils/common.utils';
import { paymentMethods } from '../paymentMethods';
import { FormInput } from '../FundWallet';
import { PropsFromRedux } from '.';
import { WALLET_RESPONSE } from '../../../interfaces/wallet.interface';
import { API_KEYS } from '../../../interfaces/api';
import { USER } from '../../../interfaces/auth.interface';
import { BeatLoader } from '../../Spinners/Spinner';
import { ReactComponent as Flutterwave } from '../../../assets/images/flutterwave.svg';
import { ReactComponent as PayStack } from '../../../assets/images/paystack.svg';
import { ReactComponent as Cellulant } from '../../../assets/images/cellulant.svg';
import { ReactComponent as KoraPay } from '../../../assets/images/korakora.svg';
import { ReactComponent as Sterling } from '../../../assets/images/sterling-img2.svg';

const createRefCode = (type: 'WB' | 'WA'): string =>
  `${type}-${Math.floor(Math.random() * 1000000000 + 1)}-MWEB`;

interface Props extends PropsFromRedux {
  formValues: FormInput;
  setFormValues: React.Dispatch<React.SetStateAction<FormInput>>;
  setFormStep: React.Dispatch<
    React.SetStateAction<'amount' | 'payment_method'>
  >;
}

const schema = yup.object().shape({
  OnlinePaymentType: yup
    .string()
    .required(getRequiredErrorMessage('Payment Method')),
});

interface Inputs {
  OnlinePaymentType: string;
}

const PaymentMethods: React.FC<Props> = ({
  walletShipments,
  formValues,
  paymentLogState,
  user,
  verifyPayment,
  hideModal,
  resetApi,
  addWalletPaymentLog,
  getPaymentByCountry,
  paymentCountryState,
  checkCellulantEncryptionState,
  checkEncryption,
  getEquivalent,
  getEquivalentState,
  generateCheckout,
  getCheckoutState

}) => {
  const { handleSubmit, register, watch } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  React.useEffect(
    () => () => {
      resetApi(API_KEYS.GET_CURRENCY_EQUIVALENT);
      resetApi(API_KEYS.GENERATE_CHECKOUT_URL);
      resetApi(API_KEYS.GET_PAYMENTMETHOD_BY_COUNTRY);
      resetApi(API_KEYS.CHECK_CELLULANT_ENCRYPTION);
      resetApi(API_KEYS.ADD_WALLET_PAYMENT_LOG);
      resetApi(API_KEYS.VERIFY_PAYMENT);
    },
    [resetApi]
  );
 
  const history = useHistory();
  const location = useLocation();
  const paymentMethod = watch('OnlinePaymentType');
  const refCode = createRefCode('WA');
  const shipmentObject: WALLET_RESPONSE = walletShipments?.response?.Object;
  const userObj: USER = user?.response?.Object;
  const countryId = userObj?.Country.CountryId;
  const equivalentState = getEquivalentState?.response?.Object;
  const paymentCountryObj = paymentCountryState?.response?.Object;
  const encryptionObj = checkCellulantEncryptionState?.response?.Object;
  const checkoutLoading = getCheckoutState?.loading;
  let convertedAmount : any;
  let convertedSymbol : any;
  let convertedCountryCode : any;
  let cardName : any;
  let cardType : any;
  const [countryCode, setCountryCode] = React.useState('');
  const [countryAmount, setCountryAmount] = React.useState(0);
  const [cardtype, setCardtype] = React.useState('');
  const [amountValue, setAmountValue] = React.useState(0);
  const [currencyCodeValue, setCurrencyCode] = React.useState<any>('') ;
  const [countryCodeUnit, setCountryUnit] = React.useState('');
  const [checkLoadStat, setLoadState ] = React.useState(checkoutLoading);

React.useEffect(() => {
    if(equivalentState){
      setAmountValue(countryAmount);
      setCurrencyCode(countryCode);
    }
    else {
      setAmountValue(formValues.Amount);
      setCurrencyCode(userObj?.Country?.CurrencyCode);
    }
})


React.useEffect(() => {
  if(!equivalentState || equivalentState == undefined){
    if(userObj?.Country?.CountryId === 1) {
      setCountryUnit('NG');
    }
    else if(userObj?.Country?.CountryId === 76){
      setCountryUnit('GH');
    }
  }
},[!equivalentState, userObj?.Country?.CountryId, setCountryUnit])

const paystackConfig: PaystackProps = {
    reference: paymentLogState?.request?.Reference,
    email: userObj?.Email,
    amount: amountValue * 100,
    currency : currencyCodeValue,
    metadata: {
      custom_fields: [
        {
          display_name: 'Paid via',
          variable_name: 'paid_via',
          value: 'GIGL-GO WEB',
        },
        {
          display_name: 'Mobile Number',
          variable_name: 'mobile_number',
          value: userObj.PhoneNumber,
        },
      ],
    },
    publicKey: process.env.REACT_APP_PAYSTACK_KEY || '',
};

//  const flutterwaveConfig: FlutterwaveConfig = {
//     public_key: process.env.REACT_APP_FLUTTERWAVE_KEY || '',
//     tx_ref: paymentLogState?.request?.Reference,
//     amount: amountValue,
//     currency: currencyCodeValue,
//     payment_options: 'card,mobilemoney,ussd,',
//     customer: {
//       email: userObj?.Email,
//       phonenumber: userObj?.Email,
//       name: `${userObj?.FirstName} ${userObj?.LastName}`,
//     },
//     customizations: {
//       title: 'GIG Logistics',
//       description: 'Wallet Payment',
//       logo: 'https://cargo-giglogistics.azurewebsites.net/static/media/logo.1c67b3c3.png',
//     },
//   };

  const sterlingConfig : FlutterwaveConfig = {
    public_key: process.env.REACT_APP_STERLING_KEY || '',
    tx_ref: paymentLogState?.request?.Reference,
    amount: amountValue,
    currency: currencyCodeValue,
    payment_options: 'card,mobilemoney,ussd,',
    customer: {
      email: userObj?.Email,
      phonenumber: userObj?.Email,
      name: `${userObj?.FirstName} ${userObj?.LastName}`,
    },
    customizations: {
      title: 'GIG Logistics',
      description: 'Wallet Payment',
      logo: 'https://giglogistics.com/static/media/logo.1c67b3c3.png',
    },
  }

  const initializePayment = usePaystackPayment(paystackConfig);
  const handleSterlingPayment = useFlutterwave(sterlingConfig);
  // const handleFlutterPayment = useFlutterwave(flutterwaveConfig);

  // React.useEffect(() => {
  //   if(formValues.CardCode == 0 || userObj?.Country?.CountryId == 1 || userObj?.Country?.CountryId == 76){
  //     getPaymentByCountry(countryId);
  //   }
  //   else if(formValues.CardCode !== 0 && userObj?.Country?.CountryId !== 1 && userObj?.Country?.CountryId !== 76) {
  //     getPaymentByCountry(formValues.CardCode);
  //   }
  // },[getPaymentByCountry, userObj?.Country?.CountryId,formValues.CardCode]);


  const koraPay = () => {
    const baseUrl : any = 'https://api.korapay.com';
    const chargeCard = `${baseUrl}/api/v1/charges/card`;
  }

  const koraConfig = () => {
    const data = {
      reference: paymentLogState?.request?.Reference,
      amount: amountValue,
      redirect_url: "https://giglogistics.com/wallet/transactions",
      currency : currencyCodeValue,
      narration: "New payment",
      customer: {
          name: userObj?.FirstName,
          email:  userObj?.Email
      }
    }

    // https://agilitysystemapidevm.azurewebsites.net/api/portal/generatecheckouturl
    generateCheckout(data);
    // fetch('https://api.korapay.com/merchant/api/v1/charges/initialize', { 
    //   method: 'post', 
    //   headers: new Headers({
    //     'Authorization': `Bearer ${userObj?.access_token}`, 
    //     'Content-Type': 'application/json'
    //   }), 
    //   body: JSON.stringify(data)
    // });
    
  }


  React.useEffect(() => {
    if(formValues.CardCode == 0 && userObj?.Country?.CountryId == 1 || userObj?.Country?.CountryId == 76) {
      getPaymentByCountry(countryId);
    }
  },[getPaymentByCountry, userObj?.Country?.CountryId, formValues.CardCode]);


  React.useEffect(() => {
    if(formValues.CardCode !== 0 && userObj?.Country?.CountryId !== 1 && userObj?.Country?.CountryId !== 76) {
      getPaymentByCountry(formValues.CardCode);
    }
  },[getPaymentByCountry, userObj?.Country?.CountryId, formValues.CardCode]);


  React.useEffect(() => {
    if(formValues.CardCode !== 0 && userObj?.Country?.CountryId !== 1 && userObj?.Country?.CountryId !== 76){
      getEquivalent({
        Amount: formValues.Amount,
        CountryId : countryId
      });
    }
  },[getEquivalent, countryId, formValues.CardCode, userObj?.Country?.CountryId])

  const onSubmit = (data: Inputs) => {};

  const addPaymentLog = (e: any) => {
    const { value } = e.target;
    let amount;
    let code;
    let converted;
    let cardtypeVal;
   
        if(equivalentState){
          amount = countryAmount;
          code = countryCode;
          converted = true;
          cardtypeVal = cardtype
        }
        else {
          amount = formValues.Amount;
          code = userObj?.Country?.CurrencyCode
          converted = false;
          cardtypeVal = 'Naira';
        }
    addWalletPaymentLog({
      IsWalletCredited: false,
      Reference: refCode,
      TransactionStatus: null,
      Amount: amount,
      WalletId: shipmentObject?.WalletId,
      OnlinePaymentType: value,
      isConverted : converted,
      CardType : cardtypeVal,
      Wallet: {
        WalletBalance: shipmentObject?.WalletNumber,
        WalletId: shipmentObject?.WalletId,
        WalletNumber: shipmentObject?.WalletNumber,
        WalletOwnerName: shipmentObject?.WalletOwnerName,
      },
    });
  };

  const encryptionCall = () => {
    let Amount;
    let Code;
    if(equivalentState){
      Amount = countryAmount;
      Code = countryCode;
    }
    else {
      Amount = formValues.Amount;
      Code = userObj?.Country?.CurrencyCode
    }
    if(paymentLogState?.success){
      const cellulantPayload = {
        merchantTransactionID : refCode,
        requestAmount : Amount,
        currencyCode : Code,
        accountNumber : refCode,
        requestDescription : 'Fund Wallet',
        countryCode : countryCodeUnit,
        languageCode : 'en',
        MSISDN : userObj?.PhoneNumber,
        customerFirstName : userObj?.FirstName,
        customerLastName : userObj?.LastName,
        customerEmail : userObj?.Email,
        successRedirectUrl : 'https://cargo-giglogistics.azurewebsites.net/wallet/transactions',  
        failRedirectUrl : 'https://cargo-giglogistics.azurewebsites.net/wallet/transactions',
        pendingRedirectUrl : 'https://cargo-giglogistics.azurewebsites.net/wallet/fund',
        paymentWebhookUrl : `${process.env.REACT_APP_DEV_URI}portal/verifypayment`
      }
      fetch('https://agilitysystemapidevm.azurewebsites.net/api/portal/checkoutencryption', { 
        method: 'post', 
        headers: new Headers({
          'Authorization': `Bearer ${userObj?.access_token}`, 
          'Content-Type': 'application/json'
        }), 
        body: JSON.stringify(cellulantPayload)
      });
    }

   
  }
 
  const getEncryption = () => {
    let Amount;
    let Code;
        if(equivalentState){
          Amount = countryAmount;
          Code = countryCode;
        }
        else {
          Amount = formValues.Amount;
          Code = userObj?.Country?.CurrencyCode
        }
        if(paymentLogState?.success){
          const cellulantPayload = {
            merchantTransactionID : paymentLogState?.request?.Reference,
            requestAmount : Amount,
            currencyCode : Code,
            accountNumber : paymentLogState?.request?.Reference,
            requestDescription : 'Fund Wallet',
            countryCode : countryCodeUnit,
            languageCode : 'en',
            MSISDN : userObj?.PhoneNumber,
            customerFirstName : userObj?.FirstName,
            customerLastName : userObj?.LastName,
            customerEmail : userObj?.Email,
            successRedirectUrl : 'https://giglogistics.com/wallet/transactions',  
            failRedirectUrl : 'https://giglogistics.com/wallet/transactions',
            pendingRedirectUrl : 'https://giglogistics.com/wallet/transactions',
            paymentWebhookUrl : 'https://mobile.gigl-go.com/api/portal/verifypayment'
          }
          checkEncryption(cellulantPayload);
        }
  } 

  React.useEffect(() => {
    if(encryptionObj){
      resetApi(API_KEYS.CHECK_CELLULANT_ENCRYPTION);
      cellulantConfig();
      resetApi(API_KEYS.GET_CURRENCY_EQUIVALENT);
      // if(encryptionObj) {
      //   const cellulantUrl = `https://online.tingg.africa/v2/modal/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${countryCodeUnit}`
      //   window.open(cellulantUrl, "_self");
      // }
      // const newUrl = `"https://developer.tingg.africa/checkout/v2/modal/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${encryptionObj?.countryCode}"`
    }
  },[encryptionObj])

  React.useEffect(() => {
    // resetApi(API_KEYS.GENERATE_CHECKOUT_URL)
    // if(paymentLogState?.request?.OnlinePaymentType === 'Korapay'){
      if(!getCheckoutState?.loading && getCheckoutState?.success && getCheckoutState?.response?.Object){
        window.open(getCheckoutState?.response?.Object, "_self");
      }
    // }
  },[!getCheckoutState?.loading, getCheckoutState?.success, getCheckoutState?.response?.Object, resetApi])

  const cellulantConfig = () => {
    if(encryptionObj) {
       const cellulantUrl = `https://online.tingg.africa/v2/express/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${countryCodeUnit}`
       window.open(cellulantUrl, "_self");
      // const cellulantUrl = `https://developer.tingg.africa/checkout/v2/express/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${countryCodeUnit}`
      // window.open(cellulantUrl, "_self");
    }
    // const cellulantUrl = `https://online.tingg.africa/v2/modal/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${encryptionObj?.currencyCodeValue}`
    // const newUrl = `"https://developer.tingg.africa/checkout/v2/modal/?accessKey=${encryptionObj?.accessKey}&params=${encryptionObj?.param}&countryCode=${encryptionObj?.countryCode}"`
    // console.log('I got to cellulant function');
    // window.open(cellulantUrl, "_self");
  }

  React.useEffect(() => {
    if(equivalentState){
      if(formValues.CardCode === 1) {
        convertedAmount = equivalentState?.NairaAmount;
        convertedCountryCode = equivalentState?.NairaCurrencyCode;
        convertedSymbol = equivalentState?.NairaCurrencySymbol;
        cardName = 'Naira Card';
        cardType = 'Naira';
        setCountryCode(equivalentState?.NairaCurrencyCode);
        setCountryAmount(equivalentState?.NairaAmount);
        setCardtype('Naira');
        setCountryUnit('NG');
      }
      else if(formValues.CardCode === 76){
        convertedAmount = equivalentState?.CediAmount;
        convertedCountryCode = equivalentState?.CediCurrencyCode;
        convertedSymbol = equivalentState?.CediCurrencySymbol;
        cardName = 'Cedis Card';
        cardType = 'Cedis';
        setCountryCode(equivalentState?.CediCurrencyCode);
        setCountryAmount(equivalentState?.CediAmount);
        setCardtype('Cedis');
        setCountryUnit('GH');
      }
      else if(formValues.CardCode === 207){
        convertedAmount = equivalentState?.DollarAmount;
        convertedCountryCode = equivalentState?.DollarCurrencyCode;
        convertedSymbol = equivalentState?.DollarCurrencySymbol;
        cardName = 'Dollar Card';
        cardType = 'Dollar';
        setCountryCode(equivalentState?.DollarCurrencyCode);
        setCountryAmount(equivalentState?.DollarAmount);
        setCardtype('Dollar');
        setCountryUnit('NG');
      }
      else if(formValues.CardCode === 62){
        convertedAmount = equivalentState?.PoundAmount;
        convertedCountryCode = equivalentState?.PoundCurrencyCode;
        convertedSymbol = equivalentState?.PoundCurrencySymbol;
        cardName = 'Pound Card';
        cardType = 'Pound';
        setCountryCode(equivalentState?.PoundCurrencyCode);
        setCountryAmount(equivalentState?.PoundAmount);
        setCardtype('Pound');
        setCountryUnit('NG');
      }
    }
  },[equivalentState, convertedCountryCode, convertedAmount, formValues.CardCode, convertedSymbol])

  React.useEffect(() => {
    
  const verifySuccessful = (ref: string) => {
      // hideModal();
      if (location.pathname.includes('wallet')) {
        history.push('/wallet');
      }
      verifyPayment(ref);
    };
    if (
      paymentLogState?.success &&
      !paymentLogState?.loading &&
      ['Paystack', 'Flutterwave', 'Cellulant', 'Sterling', 'Korapay'].includes(
        paymentLogState?.request?.OnlinePaymentType
      )
    ) {
      if (paymentLogState?.request?.OnlinePaymentType === 'Paystack') {
        const onSuccess = ({ reference }: any) => {
          verifySuccessful(reference);
        };
        const onClose = () => {};
        initializePayment(onSuccess, onClose);
      }
      if (paymentLogState?.request?.OnlinePaymentType === 'Flutterwave') {
        // handleFlutterPayment({
        //   callback: (response) => {
        //     if (response.status === 'successful') {
        //       verifySuccessful(response.tx_ref);
        //       closePaymentModal();
        //     }
        //   },
        //   onClose: () => {},
        // });
      }
      if(paymentLogState?.request?.OnlinePaymentType === 'Cellulant') {
        getEncryption();
      }
      if (paymentLogState?.request?.OnlinePaymentType === 'Sterling') {
        handleSterlingPayment({
          callback: (response) => {
            if (response.status === 'successful') {
              verifySuccessful(response.tx_ref);
              closePaymentModal();
            }
          },
          onClose: () => {},
        });
      }

      if(paymentLogState?.request?.OnlinePaymentType === 'Korapay') {
        koraConfig();
      }
      resetApi(API_KEYS.ADD_WALLET_PAYMENT_LOG);
    }
  }, [
    history,
    // handleFlutterPayment,
    handleSterlingPayment,
    location.pathname,
    hideModal,
    initializePayment,
    paymentLogState?.loading,
    paymentLogState?.request?.OnlinePaymentType,
    paymentLogState?.success,
    resetApi,
    verifyPayment,
    getEncryption,
  ]);

  return (
    
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="w-full max-w-md mx-auto text-center mb-10">
        <p className="text-xl font-semibold mb-5">
          You are about to fund your wallet with
        </p>

        {equivalentState == undefined && userObj?.Country?.CountryId === 1 &&
              <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
              {formatMoney(
                formValues.Amount,
                userObj?.Country?.CurrencyCode
              ).replace(
                userObj?.Country?.CurrencyCode,
                shipmentObject?.CurrencySymbol || '₦'
              )}
            </div>
        }

        {equivalentState == undefined && userObj?.Country?.CountryId === 76 &&
              <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
              {formatMoney(
                formValues.Amount,
                userObj?.Country?.CurrencyCode
              ).replace(
                userObj?.Country?.CurrencyCode,
                shipmentObject?.CurrencySymbol || '₦'
              )}
            </div>
        }
    
          {equivalentState !== undefined && formValues.CardCode === 1 && 
            <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
               <p>{equivalentState.NairaCurrencyCode}{equivalentState.NairaAmount}</p>
             </div>
          }

        {equivalentState !== undefined &&  formValues.CardCode === 76 && 
            <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
               <p>{equivalentState.CediCurrencyCode}{equivalentState.CediAmount}</p>
             </div>
          }

        {equivalentState !== undefined &&  formValues.CardCode === 207 && 
            <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
               <p>{equivalentState.DollarCurrencyCode}{equivalentState.DollarAmount}</p>
             </div>
          } 

        {equivalentState !== undefined &&  formValues.CardCode === 62 && 
            <div className="font-bold text-3xl inline-block text-black py-4 mb-5 px-8 border border-gray-300 rounded-lg">
               <p>{equivalentState.PoundCurrencyCode}{equivalentState.PoundAmount}</p>
             </div>
          } 

        {/* { equivalentState ? (
          <p>
            The amount {userObj?.Country?.CurrencyCode}{formValues.Amount} will be converted to {countryCode}{convertedAmount} and this will be
            deducted from your {cardName}
          </p>
           ): (
            <p>
            Funds credited to your wallet are non refundable and cannot be
            withdrawn. They shall be applied solely towards your transactions
            within GIGL ecosystem
          </p>
        )}   */}
           <p>
            Funds credited to your wallet are non refundable and cannot be
            withdrawn. They shall be applied solely towards your transactions
            within GIGL ecosystem
          </p>

          {equivalentState && userObj?.Country?.CurrencyCode !== countryCode &&
          <div className="text-red-600 text-sm text-center py-4">
            <p>
              The amount {userObj?.Country?.CurrencyCode}{formValues.Amount} will be
              converted to {countryCode}{countryAmount} and this will be
              deducted from your {cardtype} Card
            </p>
          </div>
        }
      </div>
      {/* {paymentCountryState?.loading && <BeatLoader />} */}
   
      <div className="w-full flex flex-col items-center justify-center flex-wrap max-w-xs mx-auto">
      {paymentLogState?.loading && <BeatLoader />}
      {getCheckoutState?.loading && <BeatLoader />}
      {paymentCountryState?.loading && <BeatLoader />}
      {checkCellulantEncryptionState?.loading && <BeatLoader />}
      
        {paymentCountryObj !== undefined &&
          <div>
            {paymentCountryObj.map((payment : any) => (
              <label
              className="w-full"
              htmlFor={payment.PaymentMethodId}
              key={payment.PaymentMethodId}
              >
                {payment.PaymentMethodName == 'Paystack' &&
                <div className="bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg flex items-center justify-center font-medium">
                      <PayStack />
                  </div>
                  }
                {payment.PaymentMethodName == "Cellulant" &&
                  <div className="bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg flex items-center justify-center font-medium">
                      <Cellulant />
                    </div>
                  }

                    {payment.PaymentMethodName == "Sterling" &&
                      <div className="bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg flex items-center justify-center font-medium">
                          <Sterling  />
                      </div>       
                   }

                  {payment.PaymentMethodName == "Korapay" &&
                  <div className="w-full bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg font-medium">
                    <div className="flex items-center justify-center ">
                        <KoraPay />
                    </div> 
                    <p className="text-center text-xs text-gray-600 my-2">For Nigerian Payments</p> 
                  </div>
  
                  }
                  {/* {payment.PaymentMethodName == "Flutterwave" &&
                    <div className="bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg flex items-center justify-center font-medium">
                      <Flutterwave />
                    </div>
                    } */}
                  <input
                  id={payment.PaymentMethodId}
                  name="OnlinePaymentType"
                  value={payment.PaymentMethodName}
                  onChange={addPaymentLog}
                  className="hidden"
                  ref={register}
                  disabled={paymentLogState?.loading}
                  type="radio"
                />
                  </label>
                  
                ))}
          </div>
        }
      </div>

      {/* <div className="w-full  flex flex-col items-center justify-center flex-wrap max-w-xs mx-auto">
        {paymentLogState?.loading && <BeatLoader />}
        {paymentMethods.map((paymentmethod) => (
          <label
            className="w-full"
            htmlFor={paymentmethod.id}
            key={paymentmethod.id}
          > 
          
            <div
              className={`bg-gray-200 cursor-pointer w-full p-4 my-2 rounded-lg flex items-center justify-center font-medium ${
                paymentMethod === paymentmethod.value
                  ? 'font-bold bg-gray-300'
                  : ''
              }`}
            >
              <p title={paymentmethod.name} className="text-sm">
                {paymentmethod.icon}
              </p>
            </div>

            <input
              id={paymentmethod.id}
              name="OnlinePaymentType"
              value={paymentmethod.value}
              onChange={addPaymentLog}
              className="hidden"
              ref={register}
              disabled={paymentLogState?.loading}
              type="radio"
            />
          </label>
        ))}
      </div> */}
    </form>
  );
};

export default PaymentMethods;
